import React from "react"

import FieldConfig from "../../../../fields3/proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import FieldMultiselect from "../../../generic/multiselect/multiselect"
import UserSkillsPopoverMenuMore from "./components/popover-menu-more"

export default class FieldCompanyUserSkills extends FieldMultiselect {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Company user skills";
        this.filterType         = null
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Skills"
        this.icon               = 'i5-user'

        this.options            = gd.company.settings.modules.skills.options

        this.isSearchable = true;

        this.components = _.assign({}, this.components, {
            PopoverMenuMore     : UserSkillsPopoverMenuMore
        })
    }
}
